import React, { useEffect, useState } from "react";

import fetch from "../../../utils/fetch";

interface Props {}

const VerifyEmail: React.FC<Props> = () => {
    const [code, setCode] = useState("");

    useEffect(() => {
        const path = window.location.pathname.replace(/\/$/, "").split("/");

        const code = path[2];
        setCode(code);

        if (code.length !== 36) {
            window.location.href = "/";
        } else {
            new fetch(`/verify-email?code=${code}`, {}, { success: false, error: false })
                .get()
                .then((res) => {
                    if (res.status === "success") {
                        window.location.href = "/";
                    } else {
                        window.location.href = "/";
                    }
                })
                .catch(() => {
                    window.location.href = "/";
                });
        }
    }, []);

    return <></>;
};

export default VerifyEmail;
